export const CONVERSION_TYPES = {
    PURCHASE: 'offsite_conversion.fb_pixel_purchase',
    ADD_TO_CARD: 'offsite_conversion.fb_pixel_add_to_cart',
    CHECKOUT: 'offsite_conversion.fb_pixel_initiate_checkout',
    LEAD: 'offsite_conversion.fb_pixel_lead',
};

export const CONVERSION_TYPES_LABELS = {
    [CONVERSION_TYPES.PURCHASE]: gettext('Purchase'),
    [CONVERSION_TYPES.ADD_TO_CARD]: gettext('Add to cart'),
    [CONVERSION_TYPES.CHECKOUT]: gettext('Initiate checkout'),
    [CONVERSION_TYPES.LEAD]: gettext('Lead'),
};
